import React, {useState, useRef, useEffect} from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

function calcTrackLenght(totalLaps, distanceTravelled, sessionType) {
    var trackLength = 0

    if (sessionType === 0 || sessionType === 1) {
        if (totalLaps === 1) {
            trackLength = distanceTravelled / 2
        } else {
            trackLength = distanceTravelled / (totalLaps - 1)
        }
    } else {
        if (totalLaps === 0) {return 0;}

        if (totalLaps === 1) {
            trackLength = distanceTravelled
        } else {
            trackLength = distanceTravelled / (totalLaps)
        }
    }

    return trackLength
}

const stepSize = 50

function DashboardActiveMainSpeedGraph({value}) {
    const lastDistanceRef = useRef(0);

    var completedLaps = value["completed-laps"]
    var distanceTravelled = value["distance-travelled"]
    var speed = value.speed;
    var isInPit = value["in-pitlane"] === 0 ? false : true;
    var sessionType = value["session-type"]

    var bestLap = value["best-time"]

    const [trackLength, setTrackLenght] = useState(0)
    const [totalLaps, setTotalLaps] = useState(0)
    const [lapDistanceTravelled, setLapDistanceTravelled] = useState(0)
    const [totalPoints, setTotalPoints] = useState(0)
    const [lapCounted, setLapCounted] = useState(false)

    const [isBestTime, setIsBestTime] = useState(false)

    const [speedBuffer, setSpeedBuffer] = useState(new Array(totalPoints).fill(null));
    const [bestLapBuffer, setBestLapBuffer] = useState(new Array(totalPoints).fill(null));

    useEffect(() => {
        setIsBestTime(true)
    }, [bestLap]);

    useEffect(() => {
        if (completedLaps !== totalLaps) {
            setTotalLaps(completedLaps)

            if (completedLaps !== 0) {
                setLapCounted(true)
            }
        }
    }, [completedLaps, totalLaps]);

    useEffect(() => {
        if (isInPit) {
            setSpeedBuffer(new Array(totalPoints).fill(null))
        }
    }, [isInPit, totalPoints])

    useEffect(() => {
        if (lapCounted) {
            if (isBestTime) {
                setBestLapBuffer(speedBuffer)
                setIsBestTime(false)
            }

            setTrackLenght(calcTrackLenght(totalLaps, distanceTravelled, sessionType))
            setSpeedBuffer(new Array(totalPoints).fill(null));
            setLapDistanceTravelled(distanceTravelled)
            setTotalPoints(Math.ceil(trackLength / stepSize) + 1)
            lastDistanceRef.current = 0

            setLapCounted(false)
        }
    }, [totalLaps, distanceTravelled, totalPoints, trackLength, lapCounted, sessionType, isBestTime, speedBuffer]);

    useEffect(() => {
        const index = Math.floor((distanceTravelled - lapDistanceTravelled)/ stepSize);

        if (index >= 0 && index < totalPoints) {
            setSpeedBuffer((prevArray) => {
                const tempArray = [...prevArray]; 
                
                tempArray[lastDistanceRef.current] = speed; 
                lastDistanceRef.current = index
                
                return tempArray;
            });
        }
    }, [totalPoints, speed, distanceTravelled, lastDistanceRef, lapDistanceTravelled]);

    const data = {
        labels: Array.from({ length: totalPoints }, (_, i) => `${i * stepSize}m`),
        datasets: [
        {
            data: speedBuffer,
            borderColor: '#00f2ff',
            borderWidth: 2,
            pointRadius: 0,
            fill: true,
            backgroundColor: 'rgba(0, 242, 255, 0.1)',
            tension: 0.3,
            spanGaps: false,
            zIndex: 2
        }, {
            data: bestLapBuffer,
            borderColor: 'rgba(255, 255, 255, 0.3)',
            borderWidth: 1.5,
            borderDash: [5, 5],
            pointRadius: 0,
            fill: true,
            backgroundColor: 'rgba(0, 242, 255, 0.1)',
            tension: 0.3,
            spanGaps: false,
            zIndex: 1
        },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        animation: false, // Performance massima
        scales: {
        x: {
            grid: { color: 'rgba(255,255,255,0.05)' },
            ticks: {
            maxTicksLimit: 6, // 0m, 1000m, 2000m, etc.
            color: '#64748b'
            }
        },
        y: {
            min: 0,
            max: 300,
            grid: { color: 'rgba(255,255,255,0.05)' },
            ticks: { color: '#64748b' }
        }
        },
        plugins: { legend: { display: false } }
    };

    return (
        <div className="flex flex-col gap-2 rounded-xl border border-[#324d67] bg-background-dark/40 p-4 shadow-2xl shrink-0">
            <div className="flex items-center justify-between">
                <div>
                    <p className="text-[10px] font-bold uppercase text-[#92adc9] tracking-widest leading-none mb-1">Live Speed Trace (km/h)</p>
                    <h3 className="text-2xl font-bold text-acc-cyan tracking-tighter">{Math.trunc(speed)} <span className="text-xs font-normal text-[#92adc9]">km/h</span></h3>
                </div>

                {/*
                <div className="flex gap-2">
                    <span className="flex items-center gap-1 rounded bg-acc-green/10 px-2 py-1 text-[10px] font-bold text-acc-green border border-acc-green/20">
                        <span className="material-symbols-outlined text-[12px]">trending_up</span> +4 km/h vs Best
                    </span>
                </div>
                */}
            </div>
            <div className="relative h-32 w-full mt-2">
                <Line data={data} options={options} />
            </div>
        </div>
    );
}

export default DashboardActiveMainSpeedGraph;